import { useContext } from 'react'
import { AppConfigContext } from '../contexts/AppConfigContext'
import type { AppConfigContextValue } from '../contexts/AppConfigContext'

export const useAppConfig = (): AppConfigContextValue => {
  const context = useContext(AppConfigContext)
  if (context === undefined) {
    throw new Error('useAppConfig must be used within an AppConfigProvider')
  }
  return context
}
